(window.onSubmitAtcForm = async (e, t) => {
  t.preventDefault();
  let r = e.querySelector(".btn-atc");
  (r.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `),
    e.classList.add("loading");
  let a = await fetch("/cart/add.js", {
    method: "POST",
    body: new FormData(e),
  });
  e.classList.remove("loading"),
    (r.innerHTML = window.theme.product.addedToCart),
    setTimeout(() => {
      r.innerHTML = r.dataset.textAddToCart;
    }, 2e3),
    window.refreshCartContents(a),
    !e.hasAttribute("data-ecomify-upsell-modal") &&
      !r.closest(".modal") &&
      document.querySelector("#offcanvas-cart") &&
      bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart").show();
}),
  (window.onClickAtcFormVariant = async (e, t) => {
    let r = e.closest("form");
    (r.querySelector('[name="id"]').value = e.dataset.variantId),
      window.onSubmitAtcForm(r, t);
  }),
  (window.onChangeProductOption = async (e) => {
    let t = [];
    e.closest("form")
      .querySelectorAll(".product-option")
      .forEach((e) => {
        "radio" === e.type ? e.checked && t.push(e.value) : t.push(e.value);
      });
    let r = window.productVariants.find(
      (e) => JSON.stringify(e.options) === JSON.stringify(t)
    );
    console.log(r);
    let a = e.closest("form").querySelector(".btn-atc");
    if (r) {
      (e.closest("form").querySelector('[name="id"]').value = r.id),
        r.available
          ? ((a.disabled = !1), (a.innerHTML = window.theme.product.addToCart))
          : ((a.disabled = !0), (a.innerHTML = window.theme.product.soldOut)),
        r.compare_at_price
          ? (e
              .closest(".product-content")
              .querySelector(".product-price").innerHTML = `
                <span class="product-price-compare text-muted me-3">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoney(r.compare_at_price)}
                    </s>
                </span>
                <span class="product-price-final">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(r.price)}
                </span>
            `)
          : (e
              .closest(".product-content")
              .querySelector(".product-price").innerHTML = `
                <span class="product-price-final">
                    ${Shopify.formatMoney(r.price)}
                </span>
            `),
        r.available && r.compare_at_price
          ? e
              .closest(".product-content")
              .querySelector(".product-price")
              .insertAdjacentHTML(
                "beforeend",
                `
                <span class="price-badge-sale badge">
                    ${window.theme.product.save}: ${Math.round(
                  (1 - r.price / r.compare_at_price) * 100
                )}%
                </span>    
            `
              )
          : r.available ||
            e
              .closest(".product-content")
              .querySelector(".product-price")
              .insertAdjacentHTML(
                "beforeend",
                `
                <span class="price-badge-sold-out badge">
                    ${window.theme.product.soldOut}
                </span>
            `
              );
      let o = document.querySelector("#product-purchase-options");
      o &&
        ((o.querySelector(
          "input#purchase-options-one-time + label [data-price]"
        ).textContent = Shopify.formatMoney(r.price)),
        (o.querySelector(
          "input#purchase-options-subscription + label [data-price]"
        ).textContent = Shopify.formatMoney(
          r.selling_plan_allocations[0].price
        )));
      let n = e
        .closest(".product-content")
        .querySelector(".current-variant-sku");
      if (
        (n &&
          (r.sku.length
            ? ((n.textContent = r.sku), n.removeAttribute("hidden"))
            : n.setAttribute("hidden", "hidden")),
        e.closest("#product-template"))
      ) {
        let i = new URL(window.location);
        i.searchParams.set("variant", r.id),
          window.history.replaceState({}, "", i);
      }
      let s = new CustomEvent("variantChange.ecomify.product", { detail: r });
      window.dispatchEvent(s);
    } else (a.disabled = !0), (a.innerHTML = window.theme.product.unavailable);
    e.closest(".color-swatches") &&
      (e
        .closest(".product-option-wrapper")
        .querySelector(".color-swatches-title span").textContent = e.value),
      e.closest(".size-buttons") &&
        (e
          .closest(".product-option-wrapper")
          .querySelector(".size-buttons-title span").textContent = e.value);
  }),
  window.addEventListener("variantChange.ecomify.product", async (e) => {
    let t = document.querySelector("#inventory-bar");
    t && (t.style.opacity = ".25");
    let r = await fetch(window.location.href),
      a = await r.text(),
      o = new DOMParser().parseFromString(a, "text/html");
    document
      .querySelector("#inventory-bar")
      ?.replaceWith(o.querySelector("#inventory-bar")),
      document
        .querySelector("#product-qty-breaks")
        ?.replaceWith(o.querySelector("#product-qty-breaks")),
      document
        .querySelector("#product-store-availability-wrapper")
        ?.replaceWith(o.querySelector("#product-store-availability-wrapper")),
      initInventoryBar(),
      initQtyBreaks();
  });
const initPurchaseOptions = () => {
  let e = document.querySelector("#product-purchase-options");
  if (!e) return;
  e.querySelectorAll('[name="purchase_option"]').forEach((t) => {
    t.addEventListener("change", () => {
      if ("purchase-options-one-time" === t.id) {
        if (
          (e
            .querySelector("#purchase-delivery-options")
            .setAttribute("hidden", "hidden"),
          (e.querySelector('[name="selling_plan"]').disabled = !0),
          t.closest("#product-template"))
        ) {
          let r = new URL(window.location);
          r.searchParams.delete("selling_plan"),
            window.history.replaceState({}, "", r);
        }
      } else if (
        (e
          .querySelector("#purchase-delivery-options")
          .removeAttribute("hidden"),
        (e.querySelector('[name="selling_plan"]').disabled = !1),
        t.closest("#product-template"))
      ) {
        let a = new URL(window.location);
        a.searchParams.set(
          "variant",
          e.closest(".product-content").querySelector('[name="id"]').value
        ),
          a.searchParams.set(
            "selling_plan",
            e.querySelector('[name="selling_plan"]').value
          ),
          window.history.replaceState({}, "", a);
      }
    });
  });
  let t = e.querySelector("#purchase-delivery-options-select");
  t &&
    t.addEventListener("change", () => {
      if (t.closest("#product-template")) {
        let r = new URL(window.location);
        r.searchParams.set(
          "selling_plan",
          e.querySelector('[name="selling_plan"]').value
        ),
          window.history.replaceState({}, "", r);
      }
    }),
    "true" === e.dataset.subSelectedFirst &&
      ((e.querySelector("input#purchase-options-subscription").checked = !0),
      e
        .querySelector("input#purchase-options-subscription")
        .dispatchEvent(new Event("change")));
};
initPurchaseOptions(),
  (window.onChangeProductItemVariant = (e, t) => {
    e.options[e.selectedIndex].dataset.variantImage?.length &&
      (e.closest(".product-item").querySelector(".product-item-img").src =
        e.options[e.selectedIndex].dataset.variantImage);
    let r = e.options[e.selectedIndex].dataset.compareAtPrice,
      a = e.options[e.selectedIndex].dataset.price;
    r.length
      ? (e
          .closest(".product-item")
          .querySelector(".product-item-price").innerHTML = `
            <span class="product-item-price-compare text-muted me-1">
                <span class="visually-hidden">
                    ${window.theme.product.priceFrom} &nbsp;
                </span>
                <s>
                    ${Shopify.formatMoney(r)}
                </s>
            </span>
            <span class="product-item-price-final">
                <span class="visually-hidden">
                    ${window.theme.product.priceSale} &nbsp;
                </span>
                ${Shopify.formatMoney(a)}
            </span>
        `)
      : (e
          .closest(".product-item")
          .querySelector(".product-item-price").innerHTML = `
            <span class="product-item-price-final">
                ${Shopify.formatMoney(a)}
            </span>
        `);
  }),
  (window.onClickBuyBtn = (e) => {
    e.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
    let t = e.closest("form"),
      r = t.querySelector('[name="id"]').value,
      a = Number(t.querySelector('input[name="quantity"]')?.value || 1);
    window.location.href = `/cart/${r}:${a}`;
  });
const initProductGallery = () => {
  document.querySelectorAll(".product-gallery:not(.init)").forEach((e) => {
    e.classList.add("init");
    let t = new Splide(e.querySelector(".main-splide"), {
        start: Number(e.dataset.start),
        rewind: !0,
        arrows: !1,
        rewindByDrag: !0,
        pagination: !1,
        noDrag: "model-viewer",
        mediaQuery: "min",
        breakpoints: {
          0: {
            padding: {
              right: "false" === e.dataset.showThumbsMobile ? "4rem" : 0,
            },
          },
          992: { padding: 0 },
        },
        direction: document.documentElement.getAttribute("dir"),
      }),
      r = e.querySelectorAll(".main-splide .splide__slide").length,
      a = new Splide(e.querySelector(".thumbs-splide"), {
        start: Number(e.dataset.start),
        arrows: Number(e.dataset.mediaCount > 3),
        gap: ".5rem",
        rewind: !0,
        rewindByDrag: !0,
        pagination: !1,
        isNavigation: !0,
        focus: r > 5 ? "center" : 0,
        mediaQuery: "min",
        breakpoints: {
          0: { perPage: 5 },
          576: { perPage: 5 },
          768: { perPage: 5 },
          992: { perPage: 5 },
          1200: { perPage: 5 },
          1400: { perPage: 5 },
        },
        direction: document.documentElement.getAttribute("dir"),
      });
    if (
      (t.on("move", (t, r) => {
        let a = e.querySelector(`.splide__slide:nth-child(${r + 1}) iframe`),
          o = e.querySelector(`.splide__slide:nth-child(${r + 1}) video`);
        a && (a.src = a.src), o && o.pause();
      }),
      window.addEventListener(
        "variantChange.ecomify.product",
        (e) => {
          let r = e.detail;
          r.featured_media && t.go(r.featured_media.position - 1);
        },
        !1
      ),
      t.sync(a),
      t.mount(),
      a.mount(),
      window.matchMedia("(min-width: 992px)").matches)
    ) {
      let o =
          document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight ||
          0,
        n =
          document.querySelector('[id*="__announcement-bar"].sticky-top')
            ?.clientHeight || 0;
      (e.style.position = "sticky"),
        (e.style.top = `${o + n + 20}px`),
        (e.style.zIndex = "1");
    }
    if (window.GLightbox) {
      let i = GLightbox({
        selector: `[data-gallery="product-gallery-${e.dataset.productId}"]`,
        videosWidth: "1290px",
        loop: !0,
      });
      i.on("slide_changed", ({ prev: e, current: r }) => {
        t.go(r.index);
      });
    }
    let s = e.querySelector("model-viewer");
    if (s) {
      let c = e.querySelector("[data-model-3d-increase-zoom]"),
        l = e.querySelector("[data-model-3d-decrease-zoom]"),
        d = e.querySelector("[data-model-3d-fullscreen]");
      c.addEventListener("click", () => {
        s.zoom(1);
      }),
        l.addEventListener("click", () => {
          s.zoom(-1);
        }),
        d.addEventListener("click", () => {
          document.fullscreenElement
            ? (document.exitFullscreen(),
              d.querySelector(".bi-fullscreen").removeAttribute("hidden"),
              d
                .querySelector(".bi-fullscreen-exit")
                .setAttribute("hidden", "hidden"))
            : (s.closest(".product-gallery-model-3d").requestFullscreen(),
              d
                .querySelector(".bi-fullscreen")
                .setAttribute("hidden", "hidden"),
              d.querySelector(".bi-fullscreen-exit").removeAttribute("hidden"));
        });
    }
  });
};
initProductGallery(),
  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelector(".product-gallery") && initProductGallery();
  }),
  window.addEventListener("updated.ecomify.collection", initProductGallery);
const initInventoryBar = () => {
  let e = document.querySelector("#inventory-bar");
  if (!e) return;
  let t = e.querySelector(".progress-bar");
  setTimeout(() => {
    t.style.width = t.dataset.width;
  }, 250);
};
initInventoryBar(),
  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelector("#inventory-bar") && initInventoryBar();
  });
const initUpsellModal = () => {
  let e = document.querySelector("#product-upsell-modal");
  if (!e) return;
  let t = document.querySelector(
    '#product-content form[onsubmit*="onSubmitAtcForm"]'
  );
  t &&
    (t.setAttribute("data-ecomify-upsell-modal", "true"),
    t.addEventListener("submit", (e) => {
      let t = bootstrap.Modal.getOrCreateInstance("#product-upsell-modal");
      t.show();
    }),
    document.querySelectorAll("#product-upsell-modal .btn-atc").forEach((e) => {
      e.addEventListener("click", () => {
        let e = document.querySelector(
          "#product-upsell-modal .modal-footer .btn"
        );
        e.classList.remove(e.dataset.defaultClass),
          e.classList.add(e.dataset.activeClass);
      });
    }),
    e.addEventListener("hidden.bs.modal", () => {
      if (document.querySelector("#offcanvas-cart")) {
        let e = bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart");
        e.show();
      }
    }));
};
initUpsellModal(),
  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelector("#product-upsell-modal") && initUpsellModal();
  });
const initBoughtTogether = () => {
  if (!document.querySelector("#product-bought-together")) return;
  let e = () => {
    let e = 0,
      t = 0;
    document
      .querySelectorAll("#product-bought-together .product-item-price")
      .forEach((r) => {
        r
          .closest(".product-item")
          .querySelector(".bought-together-check:checked") &&
          ((e += r.dataset.compareAtPrice.length
            ? Number(r.dataset.compareAtPrice)
            : Number(r.dataset.price)),
          (t += Number(r.dataset.price)));
      });
    let r = document.querySelector("#bought-together-total");
    e > t
      ? (r.innerHTML = `
                ${r.dataset.textTotalPrice}: 
                <span class="bought-together-total-compare-price text-muted me-2">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoney(e)}
                    </s>
                </span>
                <span class="bought-together-total-price text-success">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(t)}
                </span>
            `)
      : (r.innerHTML = `
                ${r.dataset.textTotalPrice}: 
                <span class="bought-together-total-price">
                    ${Shopify.formatMoney(t)}
                </span>
            `);
  };
  document.querySelectorAll(".bought-together-check").forEach((t) => {
    t.addEventListener("change", () => {
      t.checked
        ? (t.closest(".product-item").style.opacity = "1")
        : (t.closest(".product-item").style.opacity = ".5"),
        document.querySelector(".bought-together-check:checked")
          ? (document.querySelector("#bought-together-atc").disabled = !1)
          : (document.querySelector("#bought-together-atc").disabled = !0),
        e();
    });
  }),
    document
      .querySelectorAll('#product-bought-together select[name="id"]')
      .forEach((t) => {
        t.addEventListener("change", () => {
          let r = t.options[t.selectedIndex].dataset.compareAtPrice,
            a = t.options[t.selectedIndex].dataset.price;
          t
            .closest(".product-item")
            .querySelector(".product-item-price")
            .setAttribute("data-compare-at-price", r),
            t
              .closest(".product-item")
              .querySelector(".product-item-price")
              .setAttribute("data-price", a),
            e();
        });
      }),
    document
      .querySelector("#bought-together-atc")
      .addEventListener("click", async (e) => {
        let t = e.target;
        (t.style.width = t.clientWidth + 4 + "px"),
          (t.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `);
        let r = [];
        document
          .querySelectorAll("#product-bought-together .product-item")
          .forEach((e) => {
            e.querySelector(".bought-together-check:checked") &&
              r.push({
                id: Number(e.querySelector('[name="id"]').value),
                quantity: 1,
              });
          });
        let a = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: r }),
        });
        (t.innerHTML = window.theme.product.addedToCart),
          setTimeout(() => {
            t.innerHTML = t.dataset.textAddToCart;
          }, 2e3),
          window.refreshCartContents(a),
          bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart").show();
      });
};
initBoughtTogether();
const initQtyBreaks = () => {
  document.querySelectorAll('[name="product-qty-breaks"]').forEach((e) => {
    e.addEventListener("change", () => {
      let t = Number(e.dataset.qty),
        r = e.closest("form").querySelector('[name="quantity"]'),
        a = e.closest("form").querySelector('button[name="add"]');
      r &&
        ((r.value = t),
        setTimeout(() => {
          a.classList.add("animate__animated", "animate__shakeX");
        }, 250),
        setTimeout(() => {
          a.classList.remove("animate__animated", "animate__shakeX");
        }, 1500));
    });
  });
};
initQtyBreaks();
const initPrevNextButtons = async () => {
  let e = document.querySelector("#product-prev-next");
  if (!e || !window.matchMedia("(max-width: 1599px)").matches) return;
  await new Promise((e) => setTimeout(e, 1e3));
  let t =
    document
      .querySelector('.product-content form[action*="/cart/add"]')
      .getBoundingClientRect().bottom + window.scrollY;
  console.log(t),
    window.addEventListener("scroll", () => {
      window.scrollY > t ? e.classList.add("show") : e.classList.remove("show");
    });
};
initPrevNextButtons();
const initPersonalization = () => {
  document
    .querySelectorAll('.product-personalization-field[data-type="checkbox"]')
    .forEach((e) => {
      let t = [];
      e.querySelectorAll("input").forEach((r) => {
        r.addEventListener("change", () => {
          r.checked ? t.push(r.value) : (t = t.filter((e) => e !== r.value)),
            (e.querySelector('[type="hidden"]').value = t.join(", "));
        });
      });
    });
};
initPersonalization();
const initLimitedOffer = () => {
  let e = document.querySelector("#product-limited-offer");
  if (!e) return;
  let t = e.querySelector(".block-icon");
  setInterval(() => {
    t.classList.add("animate__animated", "animate__tada"),
      setTimeout(() => {
        t.classList.remove("animate__animated", "animate__tada");
      }, 1500);
  }, 3e3);
};
initLimitedOffer();
